// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".email-form[data-v-9bb3f156] {\n  width: 100%;\n  height: 100%;\n  position: relative;\n}\n.email-form .form[data-v-9bb3f156] {\n  width: 60%;\n  display: inline-block;\n}\n.email-form .btnhandles[data-v-9bb3f156] {\n  position: absolute;\n  top: 20px;\n  right: 20px;\n}\n.email-form .btnhandles button[data-v-9bb3f156] {\n  margin-left: 10px;\n}", ""]);
// Exports
module.exports = exports;
